/*
  Produkt Tabs / Akkordeon — Steuerung
  Gehoert nach: assets/pt-tabs-accordeon.js

  NICHT product-tabs.js nennen — dieser Name ist im FoxTheme bereits belegt
  (Custom Element <div is="product-tabs">, gehoert zu einer anderen Section).

  Einbinden in layout/theme.liquid vor </head>:
    <script src="{{ 'pt-tabs-accordeon.js' | asset_url }}" defer="defer"></script>

  WICHTIG: Diese Datei darf NICHT als Inline-Script in die Section,
  weil Apps wie King LinkedOptions den Produktbereich per innerHTML
  aufbauen — dabei fuehrt der Browser eingebettete <script>-Tags nicht aus.
*/
(function () {
  'use strict';

  if (window.__productTabsInit) return;
  window.__productTabsInit = true;

  var DESKTOP = '(min-width: 1150px)';
  var mq = window.matchMedia(DESKTOP);

  function togglesIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-pt-toggle]'));
  }

  // Panel relativ zum Button aufloesen, nicht ueber getElementById:
  // robust gegen doppelte IDs, falls eine App eine zweite Kopie einhaengt.
  function panelOf(btn) {
    var item = btn.closest('.pt-item');
    var panel = item ? item.querySelector('.pt-panel') : null;
    return panel || document.getElementById(btn.getAttribute('aria-controls'));
  }

  function set(btn, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var panel = panelOf(btn);
    if (panel) panel.hidden = !open;
  }

  // Ein einziger delegierter Listener am document.
  // Capture-Phase, damit ein stopPropagation anderer Apps nicht dazwischenfunkt.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-pt-toggle]');
      if (!btn) return;
      var root = btn.closest('[data-pt-root]');
      if (!root) return;

      var open = btn.getAttribute('aria-expanded') === 'true';

      if (mq.matches) {
        if (open) return; // Desktop: immer genau ein Tab offen
        togglesIn(root).forEach(function (b) {
          set(b, false);
        });
        set(btn, true);
      } else {
        set(btn, !open); // Mobile: unabhaengig auf/zu
      }
    },
    true
  );

  // Auf Desktop pro Section auf genau einen offenen Tab reduzieren
  function syncAll() {
    if (!mq.matches) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-pt-root]'),
      function (root) {
        var btns = togglesIn(root);
        if (!btns.length) return;
        var keep = null;
        btns.forEach(function (b) {
          if (b.getAttribute('aria-expanded') === 'true' && !keep) keep = b;
          else set(b, false);
        });
        set(keep || btns[0], true);
      }
    );
  }

  if (mq.addEventListener) mq.addEventListener('change', syncAll);
  else if (mq.addListener) mq.addListener(syncAll);

  // Nach Varianten-Wechsel durch King LinkedOptions neu einregeln
  document.addEventListener('king-linked-options:product-seamless-switched', syncAll);
  document.addEventListener('shopify:section:load', syncAll);

  // Theme-Editor: ausgewaehlten Block oeffnen
  document.addEventListener('shopify:block:select', function (e) {
    var btn = e.target.querySelector && e.target.querySelector('[data-pt-toggle]');
    if (!btn) return;
    var root = btn.closest('[data-pt-root]');
    if (root && mq.matches) {
      togglesIn(root).forEach(function (b) {
        set(b, false);
      });
    }
    set(btn, true);
  });

  // Fallback: Wenn die App den DOM ohne erkennbares Event austauscht,
  // faengt der Observer den neuen Zustand ab.
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      syncAll();
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
